{
  const isLog = true;
  // 获取页面信息
  function get_page_info(){
    let obj = {
      page_category:"",
      page_name:"",
    }
    const test = window.location.pathname;  
    const index = test.lastIndexOf("\/");  
    obj.page_category = test.slice(1,index) || 'Home'  
    obj.page_name = test.substring(index + 1,test.length) || 'Home'
    return obj;
  }
  // 发送ga4事件
  function send_ga4_event(data){
    let send_data = {
      ...data,
      page_category: data.page_category || get_page_info().page_category,
      page_name: data.page_name || get_page_info().page_name,
    }
    if(!window.dataLayer){
      log_error("window.dataLayer 未初始化");
      return false;
    }
    window.dataLayer.push(send_data);
    if(isLog){
      log(send_data);
    }
  }
  // 打印上报数据
  function log(data){
    console.log("%c " + data.event +"【ga4Event 数据上报】:"+ "\n", 'background: #007934; color: white', data);
  }

  function log_error(data){
    console.log("%c " + data.event +"【ga4Event 数据上报】:"+ "\n", 'background: red; color: white', data);
  }

// 首页 出现 
  // topbar 点击事件
  function topbar_click(){
    document.querySelectorAll('.announcement-bar').forEach(item=>{
      let domList = item.querySelectorAll('a');
      domList.forEach( dom =>{
        dom.addEventListener("click",(e)=>{
          send_ga4_event({
            event:"promotion_click",
            position:"top promotion bar",
            promotion_name: dom.closest('.announcement-bar__text')?.textContent?.trim() || e.currentTarget.getAttribute("title"),
            click_url: dom.href
          });
        });
      });
    });
  }

  // 菜单点击事件
  function menu_click(){
    // 顶部菜单 pc
    document.querySelectorAll('.ug-header-menu-first').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"first_navi_click",
          first_navi_category: e.currentTarget.getAttribute("aria-label")
        });
      });
    });

    // 二级 【包含 产品分类+产品】 pc
    document.querySelectorAll('.mega-menu-products__nav-item,.mega-menu-products__link,.mega-menu-products__view-all-btn').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let second_navi_category = "";
        if(e.currentTarget.classList.contains('mega-menu-products__link')){
          second_navi_category = e.currentTarget.getAttribute("aria-label");
        }else if(e.currentTarget.classList.contains('mega-menu-products__view-all-btn')){
          let pro_type = e.currentTarget.getAttribute("aria-product-model");
          second_navi_category = pro_type ? pro_type + " - " + e.currentTarget.textContent.trim() : e.currentTarget.textContent.trim();
        }else{
          second_navi_category = e.currentTarget.textContent.trim();
        }
        let first_navi_category = e.currentTarget.closest('.mega-menu-products')?.querySelector('.mega-menu-products__header')?.textContent.trim();
        send_ga4_event({
          event:"second_navi_click",
          first_navi_category:first_navi_category,
          second_navi_category: second_navi_category
        });
      });
    });

    // 二级 其他跳转链接 pc
    document.querySelectorAll('.header__submenu a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let first_navi_category = e.currentTarget.closest('.list-menu-item')?.querySelector('.ug-header-menu-first')?.textContent.trim();
        send_ga4_event({
          event:"second_navi_click",
          first_navi_category:first_navi_category,
          second_navi_category: e.currentTarget.textContent.trim() || e.currentTarget.querySelector('span')?.textContent.trim()
        });
      });
    });
    


    // 顶部菜单 移动端
    document.querySelectorAll('.ug-header-menu-first-mo').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"first_navi_click",
          first_navi_category: e.currentTarget.getAttribute("aria-label") || e.currentTarget.getAttribute("aria-controls")
        });
      });
    });

    // 二级 【包含 产品分类+产品】 移动端
    document.querySelectorAll('.mega-menu-products-mobile__tab-heading,.mega-menu-products-mobile__link,.mega-menu-products-mobile__view-all-btn').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let second_navi_category = "";
        if(e.currentTarget.classList.contains('mega-menu-products-mobile__link')){
          second_navi_category = e.currentTarget.getAttribute("aria-label");
        }else if(e.currentTarget.classList.contains('mega-menu-products-mobile__view-all-btn')){
          let pro_type =  e.currentTarget.closest('.mega-menu-products-mobile__tab').querySelector('.mega-menu-products-mobile__tab-heading')?.textContent.trim() || "";
          second_navi_category = pro_type ? pro_type + " - " + e.currentTarget.textContent.trim() : e.currentTarget.textContent.trim();
        }else{
          second_navi_category = e.currentTarget.textContent.trim();
        }
        let first_navi_category = e.currentTarget.closest('.menu-drawer__submenu').closest('li')?.querySelector('.menu-drawer__menu-item')?.getAttribute("aria-label");
        send_ga4_event({
          event:"second_navi_click",
          first_navi_category:first_navi_category,
          second_navi_category: second_navi_category
        });
      });
    });
    
    // 二级 其他跳转链接 移动端
    document.querySelectorAll('.ug-header-menu-second-mo').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let first_navi_category = e.currentTarget.closest('.menu-drawer__submenu').closest('li')?.querySelector('.menu-drawer__menu-item')?.getAttribute("aria-label");
        send_ga4_event({
          event:"second_navi_click",
          first_navi_category:first_navi_category,
          second_navi_category: e.currentTarget.textContent.trim()
        });
      });
    });

    // 社交媒体 移动端
    document.querySelectorAll('.menu-drawer__navigation .list-social a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"first_navi_click",
          first_navi_category: e.currentTarget.textContent.trim(),
        });
      });
    });
  }

  // banner 点击事件
  function banner_click(){
    document.querySelectorAll('.ug-home-banner .swiper-slide a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"hero_banner_interaction",
          banner_name:e.currentTarget.closest('.ug-home-banner .swiper-slide').querySelector('.title')?.textContent.trim(),
          banner_position:parseInt(e.currentTarget.closest('.ug-home-banner .swiper-slide').getAttribute("data-swiper-slide-index")) + 1,
          button_name:e.currentTarget.textContent.trim(),
          click_url:e.currentTarget.href
        });
      });
    });
  }

  // 产品点击事件
  function product_click(){
    document.querySelectorAll('.product-card a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let product_data = JSON.parse(item.closest('.swiper-slide')?.getAttribute("data-ga4-product") || "{}");
        send_ga4_event({
          event:"homepage_product_click",
          product_name:product_data.item_name,
          product_id:product_data.item_id,
          product_value:product_data.price,
          product_currency:"JPY",
          banner_name:e.currentTarget.closest('.product-swiper').getAttribute("data-tab-name"),
          product_position: e.currentTarget.closest('.swiper-slide').getAttribute("data-swiper-slide-index")
        });
      });
    });
  }

  //  产品卡展示 点击事件
  function scroll_feature(){
    document.querySelectorAll('.feature-nav-item').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let card_position = e.currentTarget.getAttribute("data-index") ?  parseInt(e.currentTarget.getAttribute("data-index")) + 1 : '';
        send_ga4_event({
          event:"card_interaction",
          card_name: e.currentTarget.getAttribute("data-title"),
          card_position: card_position
        });
      });
    });
  }

  // 视频 播放
  function video_play(){
    document.querySelectorAll('.ug-video-swiper .play-button').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let video_card_dom = e.currentTarget.closest('.video-card');
        let video_container_dom = e.currentTarget.closest('.video-container');
        let video_url = "";
        if(video_container_dom.querySelector('video')){
          video_url = video_container_dom.querySelector('video').getAttribute("src")?.trim() || video_container_dom.querySelector('video').querySelector("source")?.getAttribute("src")?.trim();
        }else if(video_container_dom.querySelector('iframe')){
          video_url = video_container_dom.querySelector('iframe')?.getAttribute("src")?.trim();
        }
        let video_title = video_card_dom.querySelector('.video-card-content .video-title')?.textContent.trim();
        send_ga4_event({
          event:"video",
          video_step:0,
          video_title: video_title,
          video_url: video_url
        });
      });
    });

    // 上报 视频播放进度
    document.querySelectorAll('.ug-video-swiper video').forEach(item=>{
      let maxVideoReported = 0;
      item.addEventListener("progress",(e)=>{
        // 进度 25% 50% 75% 100%
        let video_step = Math.floor(e.currentTarget.currentTime / e.currentTarget.duration * 100);
        if(video_step >= maxVideoReported + 25){
          // 更新已上报的最大滚动百分比
          maxVideoReported = video_step;
          let video_title = e.currentTarget.closest('.video-player')?.getAttribute("data-title")?.trim();
          let video_url = e.currentTarget.src || e.currentTarget.querySelector("source")?.getAttribute("src")?.trim();
          send_ga4_event({
            event:"video",
            video_step: maxVideoReported,
            video_title:video_title,
            video_url: video_url
          });
        }
      });
    });
  }

  // 博客卡片 点击事件
  function blog_card_click(){
    document.querySelectorAll('.ug-content-tabs a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"blog_interaction",
          article_title: e.currentTarget.getAttribute("data-title"),
          article_position: e.currentTarget.getAttribute("data-article-position"),
          click_url: e.currentTarget.href
        });
      });
    });
  }

  // support 点击事件
  function support_click(){
    document.querySelectorAll('.ug-custom-grid a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"support_interaction",
          banner_name: e.currentTarget.querySelector('.item-header')?.textContent.trim(),
          banner_position: e.currentTarget.getAttribute("data-index"),
          click_url: e.currentTarget.href
        });
      });
    });
  }

  //  faq 点击事件
  function faq_click(){
    document.querySelectorAll('.accordion-container .ac-trigger').forEach(item=>{
      
      item.addEventListener("click",(e)=>{
        let card_position = e.currentTarget.getAttribute("aria-controls")?.replace(/\D/g, "");
        card_position = card_position ? parseInt(card_position) + 1 : '';
        send_ga4_event({
          event:"faq",
          card_name: e.currentTarget.textContent.trim(),
          card_position: card_position
        });
      });
    });
  }


  // footer 点击事件
  function footer_click(){
    document.querySelectorAll('ug-footer-banner a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"footer_click",
          footer_menu_category: e.currentTarget.closest('.ug-footer-banner')?.querySelector('.heading')?.textContent.trim(),
          button_name: e.currentTarget.textContent.trim(),
          click_url: e.currentTarget.href
        });
      });
    });

    document.querySelectorAll('footer a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let footer_menu_category = e.currentTarget.closest('.footer-block--menu') ? 
                      e.currentTarget.closest('.footer-block--menu').querySelector('h2')?.textContent.trim() : 
                      e.currentTarget.closest('.accordion')?.querySelector('.footer-block__heading')?.textContent.trim();
        send_ga4_event({
          event:"footer_click",
          footer_menu_category: footer_menu_category || '',
          button_name: e.currentTarget.textContent.trim(),
          click_url: e.currentTarget.href
        });
      });
    });
  }

  //  注册、登录
  function account_click(){
    // 登录 pc、moblie
    document.querySelectorAll('.header__account-login ,.menu-drawer__account').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"account_signin",
        });
      });
    });

    // 注册 pc、moblie
    document.querySelectorAll('.header__account-register ,.menu-drawer__account-register a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        send_ga4_event({
          event:"account_register",
        });
      });
    });
  }
// 首页 出现 end

// 活动页
  // 常规活动页产品卡点击事件 包括变体产品卡
  function activity_page_click(){
    document.querySelectorAll('.ug-product-ga4-div button,.ug-product-ga4-div a').forEach(item=>{
      item.addEventListener("click",(e)=>{
        let product_data = JSON.parse(e.currentTarget.closest('.ug-product-ga4-div')?.getAttribute("data-ga4-product") || "{}");
        let variant_title = e.currentTarget.closest('.ug-product-ga4-div')?.getAttribute("data-variant-title")?.trim();
        send_ga4_event({
          event:"page_action_click",
          button_name: e.currentTarget.textContent.trim(),
          product_name: variant_title || product_data.item_name,
        });
      });
    });
  }
// 活动页


  // 立即暴露到全局，避免执行时机问题
  window.send_ga4_event = send_ga4_event;

  window.addEventListener("DOMContentLoaded",()=>{
    let ga4Obj = {
      init(){
        // 全局
        topbar_click();
        menu_click();
        account_click();
        footer_click();
        
        video_play();
        support_click();

        faq_click();
        // 全局 end

        // 首页
        banner_click();
        product_click();
        scroll_feature();
        blog_card_click();

        // 活动页
        activity_page_click();       
        
      }

    }
    ga4Obj.init();
  });

}


